'use client';

import { useDebouncedState } from '@mantine/hooks';
import * as Popover from '@radix-ui/react-popover';
import { MdError } from 'react-icons/md';
import { twJoin } from 'tailwind-merge';

import { Button } from '@/components/Button';

export type ErrorTooltipProps = {
  message?: string;
};

export function ErrorTooltip({ message }: ErrorTooltipProps) {
  const [isOpen, setIsOpen] = useDebouncedState(false, 200);

  function onMouseEnter() {
    setIsOpen(true);
  }

  function onMouseLeave() {
    setIsOpen(false);
  }

  if (!message) return null;

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <Button
          className="absolute top-1/2 right-1 -translate-y-1/2 p-0"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          variant="ghost"
        >
          <MdError className="size-5 fill-red-600" />
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className={twJoin(
            'z-15 flex gap-2 p-2 py-1',
            'bg-red-600 shadow-md outline-none',
            'text-sm font-medium text-white',
          )}
          side="bottom"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Popover.Arrow className="fill-red-600 stroke-red-600 stroke-1" />

          <span>{message}</span>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
